import * as React from "react";
import moment from "moment";
import { DateRangePicker } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
interface IDateRangeProps {
  onDatesChange: (res: { startDate: any; endDate: any }) => any;
  onFocusChange: (focus: { focus: boolean }) => any;
  focusedInput: "startDate" | "endDate" | null;
  numberOfMonths?: number;
  disabled?: "startDate" | "endDate" | boolean;
  startDate?: any;
  endDate?: any;
  required?: boolean;
}

const DateRange: React.SFC<IDateRangeProps> = props => {
  return (
    <DateRangePicker
      onDatesChange={props.onDatesChange}
      onFocusChange={focus => props.onFocusChange({ focus })}
      focusedInput={props.focusedInput}
      startDate={props.startDate}
      endDate={props.endDate}
      startDateId={"startDate"}
      endDateId={"endDate"}
      required={props.required}
      minimumNights={0}
      displayFormat={"DD/MM/YYYY"}
      disabled={props.disabled}
      isOutsideRange={day => day.isAfter(moment())}
      numberOfMonths={props.numberOfMonths || 2}
      autoFocus={true}
      renderMonthElement={({ month, onMonthSelect, onYearSelect }) => (
        <div className="case-view-datepicker-select-box">
          <select
            className="case-view-datepicker-select month"
            value={month.month()}
            onChange={e => onMonthSelect(month, e.target.value)}
          >
            {moment.months().map((label, value) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
          <select
            className="case-view-datepicker-select year"
            value={month.year()}
            onChange={e => onYearSelect(month, e.target.value)}
          >
            {returnYears()}
          </select>
        </div>
      )}
    />
  );
};
const returnYears = () => {
  const years: any[] = [];
  let initialYear = 1900;
  const diifferenceYears = moment().year() + 1 - initialYear;
  Array.from(Array(diifferenceYears)).forEach(() => {
    years.push(
      <option key={initialYear} value={initialYear}>
        {initialYear}
      </option>
    );
    initialYear++;
  });
  return years;
};

export default DateRange;
